const BASE_URL = 'https://cms.jamitan.com/api/2d41868e3e0c469fb666fe02110bcee0';
export default BASE_URL